import React from 'react';
import {
  Line,
  LineChart,
  ReferenceLine,
  XAxis,
  YAxis,
  ResponsiveContainer,
} from 'recharts';
import { getAverage, getDataHighlights } from './helpers';
import COLORS from './colors';
import Dot from '../Dot';

const dotRadius = 4;
const margin = dotRadius;
const chartMargin = {
  top: margin,
  bottom: margin,
  left: margin,
  right: margin,
};

const getCenteredDomain = (min, max) => {
  if (min === max) {
    return [min - 1, max + 1];
  }

  return [min, max];
};

const Sparkline = ({ data, seriesConfig, appearance } = {}) => {
  let chartMinValue = null;
  let chartMaxValue = null;
  let content;

  if (data.length > 0) {
    content = seriesConfig.map(({ id, color }) => {
      const { stroke, referenceStroke } = COLORS[color || 'default'];
      const {
        currentIndex,
        minIndex,
        maxIndex,
        minValue,
        maxValue,
      } = getDataHighlights(data, id);

      chartMinValue = chartMinValue === null ? minValue : Math.min(chartMinValue, minValue);
      chartMaxValue = chartMaxValue === null ? maxValue : Math.max(chartMaxValue, maxValue);

      const HighlightDot = props => (
        <Dot {...props} highlights={{ currentIndex, minIndex, maxIndex }} radius={dotRadius} />
      );

      return ([
        <ReferenceLine
          key={`ref-line-${id}`}
          y={getAverage(data, id)}
          stroke={referenceStroke}
          strokeDasharray="2 2"
        />,
        <Line
          key={`line-${id}`}
          dataKey={id}
          stroke={stroke}
          dot={HighlightDot}
          strokeWidth="2"
          isAnimationActive={false}
        />,
      ]);
    });
  } else {
    content = [
      <ReferenceLine
        key="ref-line"
        y={0}
        stroke={COLORS.default.referenceStroke}
        strokeDasharray="2 2"
      />,
      <XAxis key="x-axis" hide domain={[-1, 1]} />,
    ];
  }

  return (
    <ResponsiveContainer height={(appearance === 'new' ? 28 : 45) + 2 * margin}>
      <LineChart
        data={data}
        margin={chartMargin}
      >
        {content}
        <YAxis hide domain={getCenteredDomain(chartMinValue, chartMaxValue)} />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default Sparkline;
